import { CONTACT } from "@/lib/data";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="px-4 sm:px-6 md:px-16 lg:px-20 py-12 sm:py-16 md:py-20 bg-cream">
      <div className="max-w-[1600px] mx-auto">
        <div className="grid grid-cols-12 gap-y-6 gap-x-0 sm:gap-x-6 sm:gap-y-8 mb-8 sm:mb-10 md:mb-14">
          <div className="col-span-12 md:col-span-4">
            <p className="font-mono-label text-stone-text">Contact</p>
          </div>
          <div className="col-span-12 md:col-span-8">
            <h1 className="font-serif-display text-4xl sm:text-5xl md:text-7xl leading-[1.0]">
              Find the <em className="italic text-terracotta">studio</em>.
            </h1>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-y-10 gap-x-0 md:gap-x-12 border-t border-warm pt-12 sm:pt-16">
          <div className="col-span-12 md:col-span-6">
            <p className="font-mono-label text-stone-text mb-3 sm:mb-4">Phone</p>
            <a
              data-testid="contact-phone"
              href={CONTACT.phoneHref}
              className="font-serif-display text-2xl sm:text-3xl md:text-4xl hover:text-terracotta break-all"
            >
              {CONTACT.phone}
            </a>

            <p className="font-mono-label text-stone-text mt-9 sm:mt-12 mb-3 sm:mb-4">Email</p>
            <a
              data-testid="contact-email"
              href={`mailto:${CONTACT.email}`}
              className="font-serif-display text-xl sm:text-3xl md:text-4xl hover:text-terracotta break-all"
            >
              {CONTACT.email}
            </a>

            <p className="font-mono-label text-stone-text mt-9 sm:mt-12 mb-3 sm:mb-4">Instagram</p>
            <a
              data-testid="contact-instagram"
              href={CONTACT.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Follow Terrazzo India on Instagram"
              className="group inline-flex items-center gap-3 sm:gap-4 hover:text-terracotta transition-colors"
            >
              <span className="w-11 h-11 sm:w-12 sm:h-12 flex items-center justify-center border border-ink/25 rounded-full group-hover:border-terracotta group-hover:bg-terracotta group-hover:text-cream transition-colors shrink-0">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 sm:w-5.5 sm:h-5.5">
                  <rect x="3" y="3" width="18" height="18" rx="5" />
                  <circle cx="12" cy="12" r="4" />
                  <circle cx="17.5" cy="6.5" r="0.9" fill="currentColor" />
                </svg>
              </span>
              <span className="font-serif-display text-xl sm:text-3xl md:text-4xl break-all">
                {CONTACT.instagramHandle}
              </span>
            </a>

            <p className="font-mono-label text-stone-text mt-9 sm:mt-12 mb-3 sm:mb-4">Hours</p>
            <p className="text-base sm:text-lg">{CONTACT.hours}</p>
            <p className="text-stone-text text-xs sm:text-sm mt-2">Site visits by appointment</p>
          </div>

          <div className="col-span-12 md:col-span-6">
            <p className="font-mono-label text-stone-text mb-3 sm:mb-4">Studio Address</p>
            <address className="not-italic space-y-1 text-base sm:text-lg leading-relaxed">
              {CONTACT.address.map((l) => <p key={l}>{l}</p>)}
            </address>

            <div className="mt-8 sm:mt-10 image-zoom-wrap aspect-[4/3]">
              <iframe
                title="Studio location"
                data-testid="contact-map"
                src="https://www.google.com/maps?q=Yogii+Industries+Terrazzo+India+E+D+Industrial+Estate+Saagpada+Chinchoti+Vasai+East+Maharashtra+421302&output=embed"
                className="w-full h-full"
                style={{ border: 0, filter: "grayscale(0.6) contrast(0.95)" }}
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
